import React from "react";

const AuthHeader = ({ title, description }) => {
  return (
    <div className="mb-10 text-center md:text-left">
      <h2 className="text-3xl md:text-4xl font-black text-[#004A8D] dark:text-blue-400 uppercase tracking-tighter">
        {title}
      </h2>
      <p className="text-slate-500 dark:text-slate-400 text-base mt-3 font-medium">
        {description}
      </p>
    </div>
  );
};

export default AuthHeader;